import React from 'react';
import { ToolSectionRenderer } from '../../tools/ToolPageSections';
import { ToolPageSectionFields } from './ToolPageSectionFields';
import { SECTION_TYPES, defaultSection, getSectionSummary, getSectionTypeMeta } from './shared';
import PageVisualEditor from '../pageEditor/PageVisualEditor';

export default function ToolPageVisualEditor(props) {
  const { editingSlug } = props;

  return (
    <PageVisualEditor
      {...props}
      sectionTypes={SECTION_TYPES}
      defaultSection={defaultSection}
      getSectionSummary={getSectionSummary}
      getSectionTypeMeta={getSectionTypeMeta}
      SectionFields={ToolPageSectionFields}
      renderSection={(section) => <ToolSectionRenderer section={section} />}
      publicPath={editingSlug ? `/tools/${editingSlug}` : null}
      newTitle="New tool page"
      heroVariant="tool"
    />
  );
}
